import React, { useState, useEffect } from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { imageUploadHandler } from "../../utils/mediaUtils";
import uploadFileIcon from "../../assets/images/app/digiPub/upload-file-icon.svg";
import modalCloseIcon from "../../assets/images/logo/modal-close-icon.png";

import { ERROR, showToast } from "../../utils/toastUtils";
import { CustomButton } from "../../components/CustomButton";

const PDFUploader = ({
    uploadText = "Click here to upload your file or drag and drop.",
    label = "",
    setContentPDF = () => {},
    pdfValidationMessage = "",
    uploadSubText = "Supported formats: PDF, XLSX, XLSM, XLSB",
    setPDF = () => {},
    labelClass
}) => {
    const [uploadError, setUploadError] = useState("");
    const [isDragging, setIsDragging] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadedFileName, setUploadedFileName] = useState(""); // State to store the file name

    // Effect to clear uploadError after displaying toast
    useEffect(() => {
        if (uploadError) {
            showToast(ERROR, uploadError);
            setUploadError(""); // Clear the error after showing it
        }
    }, [uploadError]);

    // Effect to clear pdfValidationMessage after displaying toast
    useEffect(() => {
        if (pdfValidationMessage) {
            showToast(ERROR, pdfValidationMessage);
        }
    }, [pdfValidationMessage]);

    const simulateFileUpload = (file) => {
        setIsUploading(true);
        setUploadProgress(0);

        const interval = setInterval(() => {
            setUploadProgress((prev) => {
                if (prev >= 100) {
                    clearInterval(interval);
                    imageUploadHandler({
                        file,
                        imagePreviewCB: (data) => {
                            setPDF(data); // Save the file data
                            setUploadedFileName(file.name); // Set the file name
                        },
                        imageErrorCB: setUploadError,
                        uploadImgCB: setContentPDF,
                        fileTypes: [
                            "application/pdf", // PDF files
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
                            "application/vnd.ms-excel.sheet.macroEnabled.12", // XLSM
                            "application/vnd.ms-excel.sheet.binary.macroEnabled.12" // XLSB
                        ],
                        customErrorMessage: "Please upload a valid PDF or Excel file."
                    });
                    setIsUploading(false);
                    return 100;
                }
                return prev + 10; // Increment progress by 10% every 200ms
            });
        }, 200);
    };

    const handleFileUpload = (file) => {
        if (file) {
            simulateFileUpload(file);
        }
    };

    const handleFileInputChange = (event) => {
        const file = event.target.files[0];
        handleFileUpload(file);
        event.target.value = ""; // Clear the file input value to allow re-uploading
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDragEnter = () => {
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setIsDragging(false);
        const file = event.dataTransfer.files[0];
        handleFileUpload(file);
    };

    const handlePDFContainerClick = () => {
        document.getElementById("fileInput").click();
    };

    const removeFile = () => {
        setUploadedFileName(""); // Clear the file name
        setPDF(null); // Reset the uploaded file data
        setContentPDF(null); // Reset the content
    };

    return (
        <FormGroup className="d-flex flex-column">
            <Label className={`${labelClass}`}>{label}</Label>

            {uploadedFileName ? (
                <div className="pdf-uploader-container uploaded-file-box  me-2">
                    <div className="uploaded-file-name">
                        {uploadedFileName}
                        <button
                            // className="custom-btn-close-popup px-0"
                            className="custom-close-btn-popup px-0 position-absolute top-0 end-0 m-2"
                            // style={{ backgroundColor: "white" }}
                            onClick={removeFile}
                            type="button"
                        >
                            <img src={modalCloseIcon} alt="Close" />
                        </button>
                    </div>
                </div>
            ) : (
                <>
                    {" "}
                    <div
                        className={`pdf-uploader-container d-flex justify-content-center align-items-center cursor-pointer p-3 ${
                            isDragging ? "dragging" : ""
                        }`}
                        onClick={handlePDFContainerClick}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >
                        <div className="d-flex align-items-center flex-column">
                            <img src={uploadFileIcon} alt="Upload file icon" />
                            <div className="file-upload-text mt-2">
                                {uploadedFileName || uploadText}
                            </div>
                            <div className="file-upload-sub-text mt-2">{uploadSubText}</div>
                        </div>
                        {isUploading && (
                            <div
                                className="progress-bar"
                                style={{
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    width: `${uploadProgress}%`,
                                    height: "4px",
                                    backgroundColor: "#e2b97d",
                                    transition: "width 0.2s ease"
                                }}
                            />
                        )}
                    </div>
                    <Input
                        type="file"
                        id="fileInput"
                        accept=".pdf, .xlsx, .xlsm, .xlsb"
                        style={{ display: "none" }}
                        onChange={handleFileInputChange}
                    />
                </>
            )}

            {/* <div
                className={`pdf-uploader-container d-flex justify-content-center align-items-center cursor-pointer p-3 ${
                    isDragging ? "dragging" : ""
                }`}
                onClick={handlePDFContainerClick}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <div className="d-flex align-items-center flex-column">
                    <img src={uploadFileIcon} alt="Upload file icon" />
                    <div className="file-upload-text mt-2">{uploadedFileName || uploadText}</div>
                    <div className="file-upload-sub-text mt-2">{uploadSubText}</div>
                </div>
                {isUploading && (
                    <div
                        className="progress-bar"
                        style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            width: `${uploadProgress}%`,
                            height: "4px",
                            backgroundColor: "#ad728b",
                            transition: "width 0.2s ease"
                        }}
                    />
                )}
            </div>
            <Input
                type="file"
                id="fileInput"
                accept=".pdf, .xlsx, .xlsm, .xlsb"
                style={{ display: "none" }}
                onChange={handleFileInputChange}
            /> */}
            {/* {uploadedFileName && (
                <div className="pdf-uploader-container uploaded-file-box mt-2 me-2">
                    <div className="uploaded-file-name">
                        {uploadedFileName}
                        <button
                            // className="custom-btn-close-popup px-0"
                            className="custom-close-btn-popup px-0 position-absolute top-0 end-0 m-2"
                            style={{ backgroundColor: "white" }}
                            onClick={removeFile}
                            type="button"
                        >
                            <img src={modalCloseIcon} alt="Close" />
                        </button>
                    </div>
                </div>
            )} */}
        </FormGroup>
    );
};

export default PDFUploader;
